import script from "./CommandStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandStatistics.vue?vue&type=script&setup=true&lang=js"

import "./CommandStatistics.vue?vue&type=style&index=0&id=7dbd03c8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dbd03c8"]])

export default __exports__